import React from "react";
import PropTypes from "prop-types";
import Noop from "shared/util/noop";

const getWindowSize = () => {
	return {
		width: window.innerWidth,
		height: window.innerHeight,
	};
};

/**
 * A React component that puts a windowshade over the site. We usually use this
 * for modals or other UI elements that need to be at the top of the visual
 * hierarchy of the site.
 * @param {Array} [props.children] An array of React components that will be
 *                                 children of the FullscreenOverlay.
 */
class FullscreenOverlay extends React.Component {
	static propTypes = {
		children: PropTypes.node,
		siblings: PropTypes.node,
		onClick: PropTypes.func,
		scrollRef: PropTypes.object,
	};

	static defaultProps = {
		scrollRef: null,
	};

	constructor(props) {
		super(props);

		if (props.scrollRef) {
			this._overlay = props.scrollRef;
		} else {
			this._overlay = React.createRef();
		}
	}

	state = getWindowSize();

	componentDidMount() {
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize = () => {
		this.setState(getWindowSize());
	};

	render() {
		const onClick = this.props.onClick || Noop;

		return (
			<React.Fragment>
				<div style={this.state} className="FullscreenOverlay" onClick={onClick} role="presentation">
					<div className="FullscreenOverlay-inner" ref={this._overlay}>
						{this.props.children}
					</div>
				</div>
				<div className="FullscreenOverlay-content">
					{this.props.siblings}
				</div>
			</React.Fragment>
		);
	}
}

export default FullscreenOverlay;



// WEBPACK FOOTER //
// ./src/shared/components/FullscreenOverlay.jsx